// extracted by mini-css-extract-plugin
export default {"react-grid-image":"react-data-grid-image__react-grid-image"};